import { CopyButton } from 'components/copy-button/copy-button';
import { formatNumberWithTooltip } from 'components/tooltip-number';
import styles from './uat-nri-calculation.module.scss';
import { UATCalculation } from './types';

type UATCalculationDisplayProps = UATCalculation;

export const UATCalculationDisplay = ({
  tractValue,
  uat,
  uatUnit,
  length,
  lengthUnit,
  participationTract,
  participationTractUnit,
  uatValueAc,
  uatValueAcUnit,
  result,
}: UATCalculationDisplayProps) => {
  // Full precision text for copy button
  const calculationText = `${tractValue} * (${uat}${uatUnit} / ${length}${lengthUnit}) * (${participationTract}${participationTractUnit} / ${uatValueAc}${uatValueAcUnit}) = ${result}`;

  return (
    <div className={styles.container}>
      <span className={styles.calculation}>
        {formatNumberWithTooltip(tractValue, 8, '0.00000000', false)} * (
        {formatNumberWithTooltip(uat, 2, '0.00', false, uatUnit)} /{' '}
        {formatNumberWithTooltip(length, 2, '0.00', false, lengthUnit)}) * (
        {formatNumberWithTooltip(
          participationTract,
          2,
          '0.00',
          false,
          participationTractUnit
        )}{' '}
        /{' '}
        {formatNumberWithTooltip(uatValueAc, 2, '0.00', false, uatValueAcUnit)})
        = {formatNumberWithTooltip(result, 8, '0.00000000', false)}
      </span>
      <CopyButton node={calculationText} />
    </div>
  );
};

// Keep for backwards compatibility
export const UATNRICalculation = UATCalculationDisplay;
